import { useEffect, useState } from "react";
import { createorder, getpayment, verifyPayment } from '../action/user';
import swal from 'sweetalert';
import { getbank, getpackage } from "./../action/user";
import AOS from 'aos';
import config from "../../lib/config";
import './payment.css';

function Package() {

    const [payment_image, setimage] = useState()
    const [payment_content, setcontent] = useState()
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }
    async function displayRazorpay(pamount, packagedetail) {
        const res = await loadScript(
            'https://checkout.razorpay.com/v1/checkout.js'
        );

        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?');
            return;
        }

        const result = await createorder(pamount * 100);

        if (!result) {
            alert('Server error. Are you online?');
            return;
        }
        const { amount, id: id, currency } = result.userValue;

        const options = {
            key: 'rzp_live_RU8PyOB7n93Av6', // Enter the Key ID generated from the Dashboard
            amount: amount,
            currency: "INR",
            name: 'Kalyana Sapthapadhi',
            description: 'Kalyana Sapthapadhi',
            // image: "/images/logo_Final_new.png",
            order_id: id,
            handler: async function (response) {
                console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrr------->");

                // const data = {
                //   orderCreationId: "order_JAWG8geMxr0j1x",
                //   razorpayPaymentId: response.razorpay_payment_id,
                //   razorpayOrderId: response.razorpay_order_id,
                //   razorpaySignature: response.razorpay_signature,
                // };

                const data = {
                    orderID: response.razorpay_order_id,
                    transaction: response,
                    packagedetail: packagedetail
                };
                console.log(data, "data------->");

                const result = await verifyPayment(data);

                if (result.userValue) {
                    swal("Payment Successful", "Your signature is valid", "success");
                } else {
                    swal("Payment Successful", "Your signature is valid", "success");
                }
                // alert(result);
            },
            prefill: {
                name: localStorage.name,
                email: '',
                contact: localStorage.phone_number,
            },
            notes: {
                address: 'Example Corporate Office',
            },
            theme: {
                color: '#61dafb',
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }

    const getpaymentData = async () => {
        var test = await getpayment();
        let image = config.API + "/images/user/" + test.userValue.image;
        setimage(image);
        setcontent(test.userValue.content);
    };

    useEffect(() => {
        //logout(history)
        getpaymentData();
        loadScript(
            'https://checkout.razorpay.com/v1/checkout.js'
        );
        window.scrollTo({ top: 550, left: 0, behavior: 'smooth' });
        // or simply just AOS.init();
        AOS.init({
            // initialise with other settings
            duration: 2000
        });
    }, [getpaymentData]);

    const [banks, setBanks] = useState([]);
    const [packages, setPackages] = useState([])
    const getPackData = async () => {

        var test = await getbank();
        setBanks(test.userValue);

        var test = await getpackage();
        var data = test.userValue.sort(
            (r1, r2) => (r1.amount > r2.amount) ? 1 : (r1.amount < r2.amount) ? -1 : 0)

        setPackages(test.userValue);
    }

    useEffect(() => {
        //logout(history)
        getPackData();
    }, []);

    // Function to format amount with commas
    const formatAmount = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Payment handler function
    const handleSubscribe = (amount, packageId) => {
        // Your Razorpay integration logic here
        console.log('Package ID:', packageId, 'Amount:', amount);
        displayRazorpay(amount, packageId);
    };

    const vipPackageInc = [
        'Dedicated Relationship Manager to assist you throughout your matchmaking journey.',
        'Personalized matchmaking services tailored to your preferences and requirements.',
        'Priority access to exclusive profiles and events.',
        'Enhanced privacy and confidentiality for your personal information.',
        'Comprehensive support and guidance from our expert team.',
    ];

    return (
        <div class="container">
            {/* <h2 class="font-great-vibes" style={{ margin:'20px' }}>
                Kalyana Sapthapadhi Packages
            </h2> */}
            <section className="ourpackages" style={{ paddingTop: '30px', display: "flex", justifyContent: "center" }} data-aos="fade-up">
                <div className="tabs container">
                    {packages.length > 0 && (
                        packages.map((pkg) => (
                            <div className="tab">
                                <div className="tab-title" style={{ fontSize: "24px" }}>{pkg.packagename}</div>
                                {/* <div className="tab-subtitle">(Net worth upto 50 Cr.)</div> */}
                            </div>
                        ))
                    )}
                    {/* <div className="tab">
                        <div className="tab-title">Silver packs</div>
                        <div className="tab-subtitle">(Net worth upto 50 Cr.)</div>
                    </div>
                    <div className="tab">
                        <div className="tab-title">Gold packs</div>
                        <div className="tab-subtitle">(Net worth 50 - 200 Cr.)</div>
                    </div>
                    <div className="tab">
                        <div className="tab-title">Diamond packs</div>
                        <div className="tab-subtitle">(Net worth more than 200 Cr.)</div>
                    </div>
                    <div className="tab">
                        <div className="tab-title">Platinum packs</div>
                        <div className="tab-subtitle">(Net worth more than 200 Cr.)</div>
                    </div> */}
                </div>
            </section>

            {/* Content Area */}
            <div className="content">
                {/* Pricing Cards - Dynamic */}
                <div className="pricing-cards">
                    {packages.length > 0 ? (
                        packages.map((pkg) => {
                            const isVip = pkg.packagename === 'VIP';

                            return (
                                <div
                                    key={pkg._id}
                                    className={`card ${pkg.isRecommended ? 'recommended' : ''} ${isVip ? 'vip-card' : ''}`}
                                    data-aos="flip-right"
                                >
                                    {pkg.isRecommended && (
                                        <div className="badge">HIGHLY RECOMMENDED ✨</div>
                                    )}

                                    {isVip && (
                                        <div className="vip-tag"> 👑</div>
                                    )}

                                    <h3 className="card-duration">
                                        {pkg.monthvalidate} {pkg.monthvalidate === 1 ? 'Month' : 'Months'}
                                        {pkg.isRecommended && <span className="info-icon"> ⓘ</span>}
                                    </h3>

                                    <div className="card-price">₹ {formatAmount(pkg.amount)}</div>

                                    <div className="package-details">
                                        <h5>Number of profiles</h5>
                                        <h3>{pkg.count}</h3>
                                    </div>

                                    <button
                                        className={`subscribe-btn ${isVip ? 'vip-btn' : ''}`}
                                        onClick={() => handleSubscribe(pkg.amount, pkg._id)}
                                    >
                                        SUBSCRIBE
                                    </button>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-packages">
                            <p>No packages available</p>
                        </div>
                    )}
                </div>
                {/* VIP Package Inclusions */}
                <div className="d-flex flex-column align-items-center justify-content-center px-3 px-md-5">
                    <div
                        className="card vip-card w-100"
                        style={{
                            maxWidth: "1250px",
                            margin: "10px auto",
                            textAlign: "left",
                        }}
                    >
                        <span>
                            <strong >
                                VIP Service
                            </strong>
                        </span>
                        <ul>
                            {vipPackageInc.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Package
